<template>
    <div>
        <page-header :title="$t('pages.admin.video.title')" icon-class="mdi mdi-frequently-asked-questions">
            <div class="text-right">
                <router-link tag="a" :to="{name: 'admin.video.upload'}" class="text-primary font-weight-bold">
                    <i class="mdi mdi-plus"></i> {{ $t('actions.upload') }}
                </router-link>
            </div>
        </page-header>

        <div class="row">
            <div class="col-12 grid-margin stretch-card">
                <video-filter :videos.sync="videos" :pagination-data.sync="paginationData" ref="filter"></video-filter>
            </div>
        </div>
        <div class="row">
            <div class="col-12 grid-margin stretch-card">
                <div class="card shadow-sm">
                    <div class="card-body">
                        <static-loading-indicator-icon :loading="$store.getters.shouldLoadLocal"/>

                        <div v-if="!$store.getters.shouldLoadLocal">
                            <h5 class="card-title mb-3">
                                {{ $t('pages.admin.video.index.title') }}
                            </h5>


                            <div class="table-responsive" v-if="videos.length">
                                <table class="table table-borderless table-striped">
                                    <thead>
                                        <tr>
                                            <td>{{ $t('pages.admin.video.model.thumbnail') }}</td>
                                            <td>{{ $t('pages.admin.video.model.title') }}</td>
                                            <td>{{ $t('pages.admin.video.model.status') }}</td>
                                            <td>{{ $t('pages.admin.video.model.duration') }}</td>
                                            <td>{{ $t('actions.actions') }}</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="video in videos" >
                                            <td width="150">
                                                <img :src="hasKissVideo(video) ? video.kiss_video.actual_thumbnail_url : 'https://placehold.it/150'" class="img-fluid"
                                                     :alt="video.title[$i18n.locale]" style="height: 72px; width: 128px; border-radius: 8px  !important;">

                                            </td>
                                            <td>{{ video.title[$i18n.locale] }}</td>
                                            <td>
                                                <span class="badge badge-success" v-if="fullyTranscoded(video)">Public</span>
                                                <span class="badge badge-warning" v-else>Currently transcoding</span>
                                            </td>
                                            <td>
                                                <span class="badge badge-dark">
                                                    {{ video.duration / 60 }} Minutes
                                                </span>
                                            </td>
                                            <td>
                                                <button class="btn btn-outline-warning btn-sm" @click="$router.push({name: 'admin.video.edit', params: {video: video.id}})">
                                                    <i class="mdi mdi-pencil"></i>
                                                </button>
                                                <button class="btn btn-outline-dark btn-sm" @click="$router.push({name: 'admin.video.stats', params: {video: video.id}})">
                                                    <i class="mdi mdi-chart-timeline-variant"></i>
                                                </button>

                                                <button class="btn btn-outline-danger btn-sm float-right" @click="selectedVideo = video">
                                                    <i class="mdi mdi-trash-can"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div class="mt-3">
                                    <pagination :data="paginationData" @pagination-change-page="loadPage"></pagination>
                                </div>

                                <video-delete-modal :selected="selectedVideo" @video-deleted="onVideoDeleted" @modal-close="selectedVideo = null"></video-delete-modal>
                            </div>
                            <div class="alert alert-secondary border-dark" v-else>
                                {{ $t('pages.admin.video.index.none_found') }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PageHeader from "../../Includes/PageHeader";
import AdminFaqRepository from "../../../repositories/Admin/AdminFaqRepository";
import StaticLoadingIndicatorIcon from "../../Includes/StaticLoadingIndicatorIcon";
import AdminVideoRepository from "../../../repositories/Admin/AdminVideoRepository";
import AdminSeriesRepository from "../../../repositories/Admin/AdminSeriesRepository";
import SeriesSelection from "./Includes/SeriesSelection";
import VideoFilter from "./Includes/VideoFilter";
import VideoDeleteModal from "./VideoDeleteModal";
export default {
    name: "VideoManagement",
    components: {VideoDeleteModal, VideoFilter, SeriesSelection, StaticLoadingIndicatorIcon, PageHeader},
    data: () => ({
        videos: [],
        paginationData: {},

        selectedVideo: null,
    }),
    methods: {
        loadPage(page) {
            this.$refs.filter.getVideos(page);
        },
        hasKissVideo(video) {
            return video.kiss_video !== undefined && video.kiss_video !== null;
        },
        fullyTranscoded(video) {
            if(!this.hasKissVideo(video))
                return false;

            return video.kiss_video.status === 'converted';
        },
        onVideoDeleted() {
            this.selectedVideo = null;
            this.$snotify.success(this.$t('actions.deleted'));
            this.$refs.filter.getVideos();
        }
    },
}
</script>

<style scoped>

</style>
